import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from '@config/app.config';
import { AccountingRepository } from '@core/repositories/accounting.repository';
import * as moment from 'moment';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ApiAccountingRepository implements AccountingRepository {
  constructor(public appConfig: AppConfig, public http: HttpClient) {}

  private setOptions() {
    return {
      responseType: 'text' as 'text',
      observe: 'response' as 'response'
    };
  }

  downloadBalanceInterface(data: any): Observable<any> {
    const dateStart = moment(data.value.date)
      .startOf('day')
      .format(this.appConfig.DATE_FORMAT);
    const dateEnd = moment(data.value.date)
      .endOf('day')
      .format(this.appConfig.DATE_FORMAT);
    const query = '?startDate=' + dateStart + '&endDate=' + dateEnd;
    return this.http.get(
      this.appConfig.SERVICES.balanceInterface.attachmentbalanceinterface.url +
        query,
      this.setOptions()
    );
  }

  downloadMasterTransfers(data: any): Observable<any> {
    const dateStart = moment(data.value.dateStart)
      .startOf('day')
      .format(this.appConfig.DATE_FORMAT);
    const dateEnd = moment(data.value.dateEnd)
      .endOf('day')
      .format(this.appConfig.DATE_FORMAT);
    const query = '?startDate=' + dateStart + '&endDate=' + dateEnd;
    return this.http.get(
      this.appConfig.SERVICES.masterTransfers.attachmentmastergiros.url + query,
      this.setOptions()
    );
  }

  downloadMovementInterface(data: any): Observable<any> {
    const dateStart = moment(data.value.date)
      .startOf('day')
      .format(this.appConfig.DATE_FORMAT);
    const dateEnd = moment(data.value.date)
      .endOf('day')
      .format(this.appConfig.DATE_FORMAT);
    const query = '?startDate=' + dateStart + '&endDate=' + dateEnd;
    return this.http.get(
      this.appConfig.SERVICES.movementInterface.attachmentmovementreport.url +
        query,
      this.setOptions()
    );
  }

  downloadTransactionsEvents(data: any): Observable<any> {
    const dateStart = moment(data.value.dateStart)
      .startOf('day')
      .format(this.appConfig.DATE_FORMAT);
    const dateEnd = moment(data.value.dateEnd)
      .endOf('day')
      .format(this.appConfig.DATE_FORMAT);
    const query = '?startDate=' + dateStart + '&endDate=' + dateEnd;
    return this.http.get(
      this.appConfig.SERVICES.transactionsEvents.attachmenttransactionsevents
        .url + query,
      this.setOptions()
    );
  }

  downloadTransactionsLogEvents(data: any): Observable<any> {
    const dateStart = moment(data.value.dateStart)
      .startOf('day')
      .format(this.appConfig.DATE_FORMAT);
    const dateEnd = moment(data.value.dateEnd)
      .endOf('day')
      .format(this.appConfig.DATE_FORMAT);
    const typeEvent = data.value.typeEvent;
    const reference = data.value.reference;
    let query = '?startDate=' + dateStart + '&endDate=' + dateEnd + '&event=' + typeEvent;
    if(reference !== '' && reference) {
      query += '&reference=' + reference; 
    } else {
      query += '&reference=-1'; 
    }
    return this.http.get(
      this.appConfig.SERVICES.logReport.attachmenttransactionslogevents
        .url + query,
      this.setOptions()
    );
  }

  downloadTotalsCosts(data: any): Observable<any> {
    const dateStart = moment(data.value.dateStart)
      .startOf('day')
      .format(this.appConfig.DATE_FORMAT);
    const dateEnd = moment(data.value.dateEnd)
      .endOf('day')
      .format(this.appConfig.DATE_FORMAT);
    const query = '?startDate=' + dateStart + '&endDate=' + dateEnd;
    return this.http.get(
      this.appConfig.SERVICES.totalsCost.attachmenttotalcostsreport
        .url + query,
      this.setOptions());
  }

  downloadTotalsCostsSentinel(data: any): Observable<any> {
    const dateStart = moment(data.value.dateStart)
      .startOf('day')
      .format(this.appConfig.DATE_FORMAT);
    const dateEnd = moment(data.value.dateEnd)
      .endOf('day')
      .format(this.appConfig.DATE_FORMAT);
    const query = '?startDate=' + dateStart + '&endDate=' + dateEnd;
    return this.http.get(
      this.appConfig.SERVICES.totalsCost.attachmensentinelreport
        .url + query,
      this.setOptions()
    );
  }

  getTypeEvent(): Observable<any> {
    const typeEvent = {
      data: [
        {
          name: 'celular',
          label: 'Celular'
        },
        {
          name: 'documentoIdentidad',
          label: 'Documento de identidad'
        },
        {
          name: 'reverso',
          label: 'Reverso'
        },
        {
          name: 'anulaciones',
          label: 'Anulaciones'
        }
      ]
    };
    return of(typeEvent);
  }
}
